<script>
/* eslint-disable no-mixed-operators */
import { mapMutations } from "vuex";
import { cloneDeep } from "lodash";
import platform from "platform";
import Chart from "chart.js";
import lineDefaults from "./lineDefaults";
import chartColors from "./chartColors";
import { Line, mixins } from "vue-chartjs";
import VisualizationFunctions from "./visualizationFunctions";
const { reactiveProp } = mixins;

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: {
    options: Object,
    chartData: Object,
  },
  // data() {
  //   return {
  //     memoChartData: null
  //   };
  // },
  watch: {
    // options: {
    //   handler(newChartOptions) {
    //     this.$data._chart.destroy();
    //     const cloneNewChartOptions = Object.assign({}, newChartOptions);
    //     cloneNewChartOptions.tooltips.callbacks.label = (tooltipItem, data) => {
    //       return `${
    //         data.datasets[tooltipItem.datasetIndex].label
    //       }: ${tooltipItem.yLabel.toLocaleString()}`;
    //     };
    //     this.renderChart(this.chartData, cloneNewChartOptions);
    //   },
    //   deep: true
    // },
    chartData: {
      handler(newChartData) {
        // try {
        // const newChartDataJson = JSON.stringify(newChartData.datasets);
        // if (this.memoChartData === newChartDataJson) {
        //   return;
        // }
        // this.memoChartData = newChartDataJson;
        this.$data._chart.destroy();
        const cloneChartOptions = Object.assign({}, this.$props.options);
        cloneChartOptions.tooltips.callbacks.label = (tooltipItem, data) => {
          return `${
            data.datasets[tooltipItem.datasetIndex].label
          }: ${tooltipItem.yLabel.toLocaleString()}`;
        };
        this.renderChart(newChartData, cloneChartOptions);
        // } catch (error) {
        //   console.log("JSON.stringify error", error.message);
        // }
      },
      // deep: true
    },
  },
  mounted() {
    window.L = this;
    Chart.defaults.bar.scales.yAxes.gridLines = { offsetGridLines: true };
    Chart.plugins.register({
      afterDatasetsDraw(chart) {
        const chartCtx = chart.ctx;
        // const percentageMap = {};
        const barDatasets = chart.data.datasets.filter((ds, idx) => {
          const meta = chart.getDatasetMeta(idx);
          if (!meta.hidden && meta.type === "bar") {
            return true;
          }
          return false;
        });

        // barDatasets.forEach(ds => {
        //   ds.data.forEach((d, idx) => {
        //     if (!percentageMap[idx]) {
        //       percentageMap[idx] = [];
        //     }
        //     percentageMap[idx].push(d);
        //   });
        // });

        // Object.keys(percentageMap).forEach(idx => {
        //   const vals = percentageMap[idx];
        //   const sum = vals.reduce((acc, val) => acc + val, 0);
        //   const percents = [];
        //   vals.forEach(v => percents.push(Math.round((v / sum) * 100, 2)));
        //   percentageMap[idx] = percents;
        // });
        // console.log(`percentageMap: ${JSON.stringify(percentageMap)}`);

        barDatasets.forEach((dataset, i) => {
          const meta = chart.getDatasetMeta(i);
          meta.data.forEach((element, index) => {
            // Draw the text in black, with the specified font
            chartCtx.fillStyle = "rgb(0, 0, 0)";
            const fontSize = 12;
            const fontStyle = "normal";
            const fontFamily = "Helvetica Neue";
            chartCtx.font = Chart.helpers.fontString(
              fontSize,
              fontStyle,
              fontFamily
            );
            // Just naively convert to string for now
            // const dataString = dataset.data[index].toString();
            // const dataString = `${percentageMap[index][i]}%`;
            // Make sure alignment settings are correct
            chartCtx.textAlign = "center";
            chartCtx.textBaseline = "middle";
            const padding = 5;
            const position = element.tooltipPosition();
            // chartCtx.fillText(
            //   dataString,
            //   position.x,
            //   position.y - fontSize / 2 - padding
            // );
          });
        });
      },
    });
    this.renderChart(this.chartData, this.options);
  },
};
</script>
